import styles from "./Button.module.css";

/**
 * variant: primary | secondary | danger | ghost
 * size: md (44px) | sm (compact, for dense admin tables)
 */
export function Button({ variant = "primary", size = "md", as: As = "button", className = "", ...props }) {
  const classes = [styles.button, styles[variant], styles[size], className].filter(Boolean).join(" ");
  return <As className={classes} {...props} />;
}
